import cn from "classnames";
import { StepLineProps } from "./types";
import styles from "./styles.module.scss";

export const StepLine = ({
  isPassed,
  isHidden,
  className,
  dataTestId,
}: StepLineProps) => (
  <span
    className={cn(
      styles.line,
      {
        [styles.passed]: isPassed,
        [styles.hidden]: isHidden,
      },
      className
    )}
    data-test-id={`${dataTestId}-line`}
  />
);
